/**
 * ✅ Centralized storage keys
 */
export const STORAGE_KEYS = {
    SESSION_ID: 'app_session_id',
    SESSION_DATA: 'sessionData',      
    PHONE_DETAIL: 'phone_detail_state',
    MINOR_DETAIL: 'minor_detail_state',
    ADDRESS_DETAIL: 'address_detail_state',
    BANK_DETAIL: 'bank_detail_state',
    DOCUMENT_STATE: 'document_submission_state',
    CONFIRMATION_STATE: 'confirmation_state',
    MEDICAL_ASSESSMENT: 'medical_assessment_state',
    VERIFIED_DETAILS: 'verified_details_state',
    FEATURE_FLAG: 'feature_flag',
    BENIFIT_TYPE: 'benifit_type'
} as const;

export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];